import React from 'react';
import { PropTypes } from 'prop-types';
import { Breadcrumbs, Icons, Heading, DisplayHtmlContent } from 'sarsaparilla';
import { Link } from 'react-router-dom';

import PermitMap from '../../../ui-permit/src/shared/components/PermitMap';

const propTypes = {
  division: PropTypes.shape({
    description: PropTypes.string
  }),
  permitDate: PropTypes.string,
  permitId: PropTypes.string,
  permitName: PropTypes.string,
  permitType: PropTypes.string,
  recarea: PropTypes.arrayOf(PropTypes.object)
};

const defaultProps = {
  division: {
    id: '',
    name: ''
  },
  permitName: ''
};

export default class DivisionDetail extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      points: null
    };
  }

  UNSAFE_componentWillMount() {
    fetch(`/shared/inyonwhitney/data/233262/features.json`, {
      credentials: 'include'
    })
      .then((response) => response.json())
      .then((json) => {
        this.setState({
          points: json.points
        });
      })
      .catch(() => {});
  }

  backToDetailedAvailability() {
    let uri = `/permits/${this.props.permitId}/registration/detailed-availability?`;

    if (this.props.permitType) {
      uri += `type=${this.props.permitType}`;
    }

    if (this.props.permitDate) {
      uri += `&date=${this.props.permitDate}`;
    }

    return uri;
  }

  renderDivisionBreadcrumb() {
    const recArea = this.props.recarea[0];

    if (recArea) {
      const path = [
        { title: 'Home', url: '/' },
        { title: recArea.name, url: `/camping/gateways/${recArea.entity_id}` },
        { title: this.props.permitName, url: `/permits/${this.props.permitId}` },
        { title: 'Detailed Availability', url: this.backToDetailedAvailability() },
        { title: this.props.division.name }
      ];

      return (
        <Breadcrumbs path={path} />
      );
    }

    return null;
  }

  renderDivisionDesc() {
    return (
      <div>
        <h1>{this.props.division?.name}</h1>
        <div id="division-permit-name">{this.props.permitName}</div>
        <div id="division-permit-desc" className="permit-division-description">
          <DisplayHtmlContent html={this.props.division?.description} />
        </div>
      </div>
    );
  }

  renderDivisionNeedToKnow() {
    const needToKnow = this.props.division?.description_map?.need_to_know ?? '';
    return (
      needToKnow && (
        <div>
          <br />
          <p>
            <Heading headingLevel={2} appearance="h5">Need to know</Heading>
          </p>
          <div id="division-permit-needToKnow" className="permit-division-needToKnow">
            <DisplayHtmlContent html={needToKnow} />
          </div>
        </div>
      )
    );
  }

  renderDivisionHeader() {
    return (
      <div className="permit-division-back-link">
        <Link to={this.backToDetailedAvailability()}><Icons.IconArrowBack /> Back to Detailed Availability</Link>
      </div>
    );
  }

  renderDivisionMap() {
    const division = this.props.division;
    const points = this.state.points;

    if (division && division.id && points) {
      let divisionId = division.id;
      let geoJson = null;

      if (typeof divisionId !== 'string') {
        divisionId = `${divisionId}`;
      }

      for (let i = 0; i < points.features.length; i++) {
        const feature = points.features[i];
        let featureId = feature.properties.id;

        if (typeof featureId !== 'string') {
          featureId = `${featureId}`;
        }

        if (divisionId === featureId) {
          geoJson = {
            features: [
              feature
            ],
            type: 'FeatureCollection'
          };
          break;
        }
      }

      if (geoJson) {
        return (
          <div className="permit-division-map" id="map">
            <PermitMap
              center={geoJson.features[0].geometry.coordinates}
              fullscreenControl={false}
              geoJsonPoints={geoJson}
              mapContainer="map"
              zoom={17} />
          </div>
        );
      }
    }

    return null;
  }

  render() {
    return (
      <div className="permit-content-outer-wrap">
        <section className="permit-content-main division-details-container">
          {this.renderDivisionBreadcrumb()}
          {this.renderDivisionHeader()}
          {this.renderDivisionDesc()}
          {this.renderDivisionMap()}
          {this.renderDivisionNeedToKnow()}
        </section>
      </div>
    );
  }
}

DivisionDetail.propTypes = propTypes;
DivisionDetail.defaultProps = defaultProps;
